var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9586 12.5034H73.2113C75.9727 12.5034 78.2113 14.742 78.2113 17.5034V26.3016C78.2113 28.5646 76.6913 30.5455 74.5054 31.1312L41.7712 39.9023C40.9234 40.1294 40.0308 40.1294 39.183 39.9023L4.7059 30.6642C2.51999 30.0785 1 28.0976 1 25.8345V13.462C1 12.9326 1.42918 12.5034 1.9586 12.5034Z",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5293 12.5033V4C24.5293 2.34315 25.8724 1 27.5293 1H51.5075C53.1644 1 54.5075 2.34315 54.5075 4V12.5033",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05444 32.6338V53.0804C6.05444 55.8418 8.29302 58.0804 11.0544 58.0804H17.2091",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1567 32.6338V53.0804C73.1567 55.8418 70.9182 58.0804 68.1567 58.0804H62.0021",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7734,
    cy: 57.7734,
    r: 14.7734,
    stroke: "#45B14A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57.9951H50",
    stroke: "#45B14A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0049 48L40.0049 68",
    stroke: "#45B14A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostJob);
export default __webpack_public_path__ + "static/media/post-job.21fd06e0036f2298c836b15ac332cb4f.svg";
export { ForwardRef as ReactComponent };